import vidur_Twari from "../assets/img/vidur_Twari.jpg";

export const headerData = {
  name: "Vidur Tiwari",
  title: "Founder & AI Automation Engineer · WebNeo Tech Corporation",
  desciption:
    "I build AI systems and automation infrastructure for businesses that are serious about not losing revenue to preventable problems.",
  image: vidur_Twari,
};
